locale = if HM.is_russian then require('date-fns/locale/ru') else require('date-fns/locale/en')

distanceInWordsToNow = require('date-fns/distance_in_words_to_now')

hm_date =
  distanceInWordsToNow: (date) ->
    result = distanceInWordsToNow(date, locale: locale)
    result + (if HM.is_russian then ' назад' else ' ago')
  addMonths: require('date-fns/add_months')
  addDays:   require('date-fns/add_days')

  format: (date, pattern = "YYYY-MM-DD") ->
    require('date-fns/format')(date, pattern, { locale: locale })
  parse:   require('date-fns/parse')
  isValid: require('date-fns/is_valid')
  startOfYear:  require('date-fns/start_of_year')
  startOfMonth: require('date-fns/start_of_month')
  startOfWeek:  require('date-fns/start_of_week')
  endOfYear:    require('date-fns/end_of_year')
  endOfMonth:   require('date-fns/end_of_month')
  endOfWeek:    require('date-fns/end_of_week')

  differenceInMonths: require('date-fns/difference_in_months')
  differenceInDays: require('date-fns/difference_in_days')

  getISOWeek: require('date-fns/get_iso_week')


hm_date.startOfMonth_f = (date) -> hm_date.format(hm_date.startOfMonth date)
hm_date.startOfYear_f  = (date) -> hm_date.format(hm_date.startOfYear date)
hm_date.endOfMonth_f   = (date) -> hm_date.format(hm_date.endOfMonth date)
hm_date.endOfYear_f    = (date) -> hm_date.format(hm_date.endOfYear date)
hm_date.addMonths_f    = (date, amount) -> hm_date.format(hm_date.addMonths date, amount)
hm_date.addDays_f      = (date, amount) -> hm_date.format(hm_date.addDays date, amount)

hm_date.constants =
  year_from_now_start_of_month: hm_date.startOfMonth_f(hm_date.addMonths(new Date, 12))
  start_of_current_month:       hm_date.startOfMonth_f(new Date)
  end_of_current_month:         hm_date.endOfMonth_f(new Date)
  today:                        hm_date.format(new Date)
  yesterday:                    hm_date.addDays_f(new Date, -1)
  tomorrow:                     hm_date.addDays_f(new Date, 1)

module.exports = hm_date
